import store_compte from '@/store/mods/caisse/compte.js'

export default {
    name: 'manage-versement-banque',
    components: {},
    props: {
        solde_courant_compte_depot: Number,
        vers_toggler: Number,
        user_info: Object
    },
    data() {
        return {
            versement_data: {
                source: null,
                destination: null,
                motif: '',
                preuve: '',
                montant: ''
            },
            source_versement: '',
            is_loading: false,
            is_empty: false,
            banques: [],

            files: [],
            preuve_is_empty: false,
            msg_error: '',
            save_loading: false
        }
    },

    watch: {
        vers_toggler() {
            this.clearError()
            this.files = []

            this.versement_data = {
                source: null,
                destination: null,
                motif: '',
                preuve: '',
                montant: ''
            }
            this.$refs.versement_form.reset()
            this.setSourceVersement()
            this.fetchBanques()
        }
    },

    computed: {
        liste_source_approvisionnement() {
            return this.$store.getters['liste_source_approvisionnement']
        },
    },

    mounted() {

    },

    methods: {
        setSourceVersement() {
            const source = this.liste_source_approvisionnement.filter(item => item.designation_source === 'Compte de dépôt')
            this.versement_data.source = source[0]
            this.source_versement = source[0].designation_source
        },

        fetchBanques() {
            this.is_loading = true

            store_compte.getCompteBanque().then((response) => {
                this.banques = response.data
                if(this.banques.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            })
        },

        handleFilesUpload() {
			let uploadedFiles = this.$refs.files.files;
			/*
				Adds the uploaded file to the files array
			*/
			this.files = []
			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push(uploadedFiles[i]);
			}

            this.versement_data.preuve = this.files[0];
		},

        clearError() {
            this.preuve_is_empty = false
            this.msg_error = ''
		},

        async save() {
            const isValid = await this.$refs.versement_form.validate();
            if (!isValid) {
                this.msg_error = 'Merci de remplir tous les champs requis * !'
                return;
            }

            if (this.versement_data.preuve == '') {
                this.msg_error = 'Merci de joindre une preuve !'
                return;
            }

            let montant = this.versement_data.montant
            montant = this.cleanNumber(montant)
            if (montant === '') {
                this.msg_error = 'Merci de saisir un nombre !'
                return;
            }

            const is_greater_zero = this.checkIfNumberGreaterThanZero(montant)
            if (!is_greater_zero) {
                this.msg_error = 'Merci de saisir un nombre strictement supérieur à 0 !'
                return;
            }

            if (montant > this.solde_courant_compte_depot) {
                this.msg_error = 'Le montant à verser doit être inférieur ou égal au solde du compte de dépôt !'
                return;
            }

            const data = {
                user_name: this.user_info.name,
                user_titre: this.user_info.titre,
                user_id: this.user_info.id,
                compte_source_id: this.versement_data.source.id,
                compte_destination_id: this.versement_data.destination.id,
                motif: this.versement_data.motif,
                montant: montant,
                preuve: this.versement_data.preuve,
                solde_au_versement: this.solde_courant_compte_depot
            }
            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key])
            }
            
            this.save_loading = true
            this.$store.dispatch('saveVersementBanque', form_data).then((response) => {
                if (response.success) {
                    this.$refs.mng_versement.click()
                    this.successToast(response.message)

                    this.$refs.versement_form.reset()
                    this.$emit("emitRefreshTresorerie")
                } else {
                    this.msg_error = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = "Une erreur est survenue lors de l'enregistrement de la banque. Veuillez réessayer plus tard."
            })
        }
    }
}